import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


const ModalOrientacao = ({open, onClose, data}) => {
    
    const {planoAcao} = data;
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        borderRadius: '20px',
        p: 4,
    };
    
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography component="h2" mb={2} mt={4} sx={{fontWeight: 'bold'}}>
                    Orientações ao cliente
                </Typography>
                <p>
                    {planoAcao}
                </p>
            
            </Box>
        </Modal>
    );
};

export default ModalOrientacao;
